<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-divider></v-divider>
          <v-card>
            <v-card-title>
              <h4>JND Conference 2024 Abstracts Review</h4>
              <v-spacer></v-spacer
              ><v-btn outline block color="lime" @click="fetchExport"
                >EXPORT</v-btn
              >
              <!--<v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            color="lime"
          ></v-text-field>-->
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="models"
              :search="search"
              :loading="loaded"
              class="elevation-0"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.page.sync="pagination"
            >
              <v-progress-linear
                slot="progress"
                color="lime"
                indeterminate
              ></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.article_number }}</td>
                <td class="text-xs-left">{{ props.item.article_name }}</td>
                <td class="text-xs-left">
                  {{ props.item.authors }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.reviewer_name }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.reviewer_email }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.abstract_status }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.comment }}
                </td>
                <td class="justify-center layout px-0">
                  <v-btn
                    outline
                    color="lime"
                    @click="fab_button(props.item)"
                    :disabled="disabled"
                  >
                    resend
                  </v-btn>
                  <v-btn
                    outline
                    color="lime"
                    @click="edit_article(props.item)"
                    :disabled="disabled"
                  >
                    edit
                  </v-btn>
                </td>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
                >Your search for "{{ search }}" found no results.</v-alert
              >
            </v-data-table>
          </v-card>
          <v-dialog v-model="downloaded" persistent width="300">
            <v-card color="lime" dark>
              <v-card-text>
                Please stand by
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import Vue from "vue"
import axios from "axios"
import swal from "sweetalert2"
import {
  jndArticleAssessmentReviewersUrl,
  jndArticleAssessmentResendUrl,
  jndArticleAssessmentExportUrl
} from "@/config"
export default {
  data() {
    return {
      rowsPerPageItems: [20, 50, 100, 200, 300, 400, 500],
      pagination: {
        sortBy: "article_name",
        descending: true,
        rowsPerPage: 20
      },
      dialog: false,
      menu: false,
      menu1: false,
      menu2: false,
      menu3: false,
      name: "Create",
      store: false,
      edit: false,
      headers: [
        { text: "Article Number", align: "left", value: "article_number" },
        { text: "Article Name", align: "left", value: "article_name" },
        { text: "Authors", align: "left", value: "authors" },
        { text: "Reviewer Name", align: "left", value: "reviewer_name" },
        { text: "Reviewer Email", align: "left", value: "reviewer_email" },
        { text: "Reviewer Status", align: "left", value: "abstract_status" },
        { text: "Comment", align: "left", value: "comment" },
        { text: "Actions", align: "center", sortable: false }
      ],
      snackbar: false,
      snackbar_text: "",
      y: "",
      x: "",
      mode: "",
      timeout: 6000,
      show_container_can: false,
      drawer: false,
      sending: false,
      errors: {},
      models: [],
      dialog: false,
      downloaded: false,
      loaded: false,
      search: "",
      disabled: false,
      error_alert_value: false,
      submit_type: false,
      launch_id: "null",
      status: ""
    }
  },
  mounted() {
    var vm = this
    this.fetchData()
    window.setIntervalConfirm_exam = setInterval(function() {
      //counter += 1
      //if (!vm.models.length) {
      vm.fetchData()
      // }
      //if (counter === 3) {
      //clearInterval(setIntervalConfirm)
      //}
    }, 20000)
  },
  beforeDestroy() {
    clearInterval(setIntervalConfirm_exam)
  },
  methods: {
    edit_article(item) {
      window.location.href =
        "https://atri.kndi.institute/#/jnd-article/conference/2024/edit/" +
        item.id
    },
    fetchData() {
      var vm = this
      vm.submit_type = false
      vm.snackbar_text = "Please stand by as background data is loading."
      vm.snackbar = true
      vm.x = "right"
      vm.y = "top"
      vm.mode = "multi-line"
      vm.timeout = 8000
      vm.loaded = true
      axios
        .get(jndArticleAssessmentReviewersUrl)
        .then(function(response) {
          if (response.data) {
            Vue.set(vm.$data, "models", response.data)
            vm.loaded = false
            vm.submit_type = true
            vm.snackbar_text = "Background data successfully loaded."
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
            vm.timeout = 3000
          }
        })
        .catch(function(error) {
          console.log(error.message)
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    },
    fab_button(id) {
      var vm = this
      var id_one = id
      swal({
        title: "Confirm",
        text: "Do you want to resend the email?",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#CDDC39",
        cancelButtonColor: "#F44336",
        confirmButtonText: "Proceed",
        cancelButtonText: "Cancel"
      }).then(result => {
        if (result.value) {
          vm.saveEdit(id_one)
        } else if (
          // Read more about handling dismissals
          result.dismiss === "cancel"
        ) {
          swal({
            title: "Cancelled",
            text: "form was not submitted",
            type: "error",
            confirmButtonColor: "#cddc39",
            confirmButtonText: "OK"
          })
        }
      })
    },
    saveEdit(id_one) {
      var vm = this
      vm.sending = true
      vm.disabled = true
      vm.downloaded = true
      vm.error_alert_value = false

      var data = {
        reviewer_email: id_one.reviewer_email,
        id: id_one.id
      }

      const options = {
        method: "POST",
        data: data,
        url: jndArticleAssessmentResendUrl
      }
      vm.downloaded = true
      axios(options)
        .then(function(response) {
          if (response.data.success) {
            swal({
              title: "Submitted",
              text: "Resent successfully",
              type: "success",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          }
          if (response.data.empty) {
            vm.error_alert_value = true
            swal({
              title: "Validation",
              text: "Fill in all fields.",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          }
          vm.sending = false
          vm.disabled = false
          vm.downloaded = false
        })
        .catch(function(error) {
          console.log(error)
          if (error.response.data) {
            Vue.set(vm.$data, "errors", error.response.data)
            vm.disabled = false
            vm.error_alert_value = true
            vm.downloaded = false
          }
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    },
    fetchExport() {
      var vm = this
      vm.downloaded = true
      vm.disabled = true

      const options = {
        method: "GET",
        url: jndArticleAssessmentExportUrl,
        responseType: "arraybuffer"
      }
      axios(options)
        .then(function(response) {
          vm.downloaded = false
          vm.disabled = false
          //console.log(response)
          if (response.data.byteLength != 0) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response.data], {
              type: "application/vnd.ms-excel"
            })

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob)
              return
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob)
            var link = document.createElement("a")
            link.href = data
            link.download = "REVIEWERS EXPORT.csv"
            document.body.appendChild(link)
            link.click()
            setTimeout(function() {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data)
            }, 100)
          } else {
            swal({
              title: "403!",
              text: "ACCESS DENIED!",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          }
        })
        .catch(function(error) {
          console.log(error.message)
          vm.disabled = false
          vm.downloaded = false
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/public/jnd-article-assessment-reviewers.vue